import React, { useEffect, useState } from 'react';
import { Box, Modal } from '@mui/material';
import './VendorOrderDetailModal.css';
import CloseIcon from '../../assets/svg/closeIcon';
import Loader from '../../Components/Loader/Loader';
import OrderInfo from '../User/Inbox/OrderInfo';
import '../../Styles/Inbox/OrderDetails.css';


function VendorOrderDetailModal({ open, handleClose, id }) {
    const [orderInvoiceData, setOrderInvoiceData] = useState(null);
    const [animateModal, setAnimateModal] = useState(false);
    const [closing, setClosing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    
    useEffect(() => {

        setClosing(false);
        setTimeout(() => {
            setAnimateModal(true);
        }, 100);
    }, []);

    return (    
        <Modal 
            open={open} 
            onClose={() => {
                setClosing(true);
                setTimeout(() => {
                    handleClose();
                }, 500);
            }}
        >
            <Box className={`style-order ${animateModal ? 'animate' : ''} ${closing ? 'close' : ''}`}>
                {isLoading && <Loader/>}
                <div className='order-detail-model-1'>
                    <div className='container-order-detail'>
                        <div className="heading-close-button">
                            <p className='order-detail-title'>Orders Detail</p>
                            <CloseIcon onClick={handleClose} className={'vendor-order-close-icon'} />
                        </div>
                        <OrderInfo setIsLoading={setIsLoading} orderInvoiceData={orderInvoiceData} setOrderInvoiceData={setOrderInvoiceData} id={id} vendor={true}/>
                    </div>
                </div>
            </Box>
        </Modal>
    );
}

export default VendorOrderDetailModal;